import { Stack } from '@mui/system';
import { FC, SVGProps } from 'react';

import { InvestmentAvailabilityStatus, InvestmentAvailabilityStatusType } from '@/api/fund/types';
import BuildingIcon from '@/assets/svg/ui-elements/building.svg';
import ClockIcon from '@/assets/svg/ui-elements/clock.svg';
import CloseIcon from '@/assets/svg/ui-elements/close.svg';
import EyeClosedIcon from '@/assets/svg/ui-elements/eye-closed.svg';
import { Typography } from '@/design-system';
import { colors } from '@/design-system/colors';

import { FundsTabTableRow } from '../data';

const investmentAvailabilityStatusBadge: Record<
  InvestmentAvailabilityStatusType | 'None',
  { label: string; color: string; icon?: FC<SVGProps<SVGSVGElement>> }
> = {
  [InvestmentAvailabilityStatus.OPEN]: {
    label: 'Open',
    color: colors.icon.info,
    icon: BuildingIcon,
  },
  [InvestmentAvailabilityStatus.CLOSED]: {
    label: 'Closed',
    color: colors.icon.error,
    icon: CloseIcon,
  },
  [InvestmentAvailabilityStatus.PRE_LAUNCH]: {
    label: 'Pre-launch',
    color: colors.icon.info,
    icon: ClockIcon,
  },
  [InvestmentAvailabilityStatus.PRIVATE]: {
    label: 'Hidden',
    color: colors.white[60],
    icon: EyeClosedIcon,
  },
  None: {
    label: 'No Status',
    color: colors.text.warning,
  },
};

type Props = Pick<FundsTabTableRow, 'investmentAvailabilityStatus'>;

export const FundAvailabilityCell: FC<Props> = ({ investmentAvailabilityStatus }) => {
  const {
    label,
    icon: Icon,
    color,
  } = investmentAvailabilityStatusBadge[investmentAvailabilityStatus ?? 'None'];
  return (
    <Stack direction="row" alignItems="center" gap="4px">
      {Icon && <Icon width={14} height={14} color={color} />}
      <Typography variant="body3" color={color}>
        {label}
      </Typography>
    </Stack>
  );
};
